import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=aaa70488&scoped=true"
import script from "./ServiceList.vue?vue&type=script&lang=js"
export * from "./ServiceList.vue?vue&type=script&lang=js"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=aaa70488&prod&lang=scss"
import style1 from "./ServiceList.vue?vue&type=style&index=1&id=aaa70488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa70488",
  null
  
)

export default component.exports